import { DropdownWrapper } from '@anm/components/Dropdown';
import { flexColumn, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const TemplateWithSliderWrapperTabletStyles = media.tablet`
  margin: 0;
  padding: 0;
`;

const TemplateWithSliderWrapper = styled.div`
  flex: 1;
  ${flexColumn};
  margin-right: 100px;
  align-items: center;
  padding: 30px 2vw 50px 6vw;
  ${DropdownWrapper} {
    display: none;
  }
  ${TemplateWithSliderWrapperTabletStyles};
  > div:last-of-type {
    margin-top: auto;
  }
`;

export default TemplateWithSliderWrapper;
